module.exports = "https://r.zoocdn.com/_next/static/images/favicon-32x32-47512d065ffbc2687a7285987d615e7f.png";